import TabsComponent from "components/uiComponents/Tabs/TabComponent";
import UniversalButton from "components/uiComponents/UniversalButton";
import { ReactComponent as BinIcon } from "../../../../static/icons/bin.svg";
import Select from "../Select/Select";
import "./ColorSidebarMainContent.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  clearColorSideBarAC,
  createColorSchemeAC,
  openSidebarAC,
  setCurrentTabIdAC,
} from "store/actions/colorSidebar";

import ConditionColorContent from "../SidebarTabsContent/ConditionColorContent";
import GradientColorContent from "../SidebarTabsContent/GradientColorContent";
import { colorSchemeType } from "utils/types";
import { useMemo } from "react";
import { clearColors } from "utils/builder/IScheduleLogic";

const ColorSidebarMainContent = ({currentTableId}) => {
  const dispatch = useDispatch();

  const {
    currentColumnValue,
    currentTabId,
    headerOptions,
    colorSettingsItems,
    gradientData
  } = useSelector((state) => state.colorSidebar);

  const columnType = currentColumnValue.type

  const tabsArray = useMemo(() => {
    return [
      {
        text: "One color",
        id: colorSchemeType.conditionalColor,
      },
      {
        text: "Gradient",
        id: colorSchemeType.gradient,
      },
    ];
  }, [])

  const tabContentObject = useMemo(() => {
    return {
      [colorSchemeType.conditionalColor]: (
        <ConditionColorContent
          colorSettingsItems={colorSettingsItems}
          columnType={columnType}
        />
      ),
      [colorSchemeType.gradient]: <GradientColorContent gradientData={gradientData}/>,
    };
  }, [columnType, colorSettingsItems, gradientData])

  const setNewValueHandler = (item) => {
    dispatch(openSidebarAC(item, item.type));
  };

  const onClearHandler = () => {
    clearColors()
    dispatch(clearColorSideBarAC());
  };

  const onSetTab = (tabId) => {
    dispatch(setCurrentTabIdAC(tabId));
  };

  const applyConditions = () => {
    clearColors()
    dispatch(createColorSchemeAC({
      currentColorSchemeType: currentTabId,
      columnKey: currentColumnValue.key,
      colorColumnType: currentColumnValue.type,
      colorItems: colorSettingsItems,
      gradientData: gradientData,
      isUniqueValue: false,
      currentTableId,
    }));
  };

  return (
    <div className="color-sidebar">
      <div className="color-sidebar-select">
        <Select
          title="Select column"
          selectedValue={currentColumnValue}
          setSelectedValue={setNewValueHandler}
          isBold
          options={headerOptions}
        />
      </div>

      <div className="color-sidebar-tabs">
        <TabsComponent
          defaultId={currentTabId}
          tabsArray={tabsArray}
          onSetTab={onSetTab}
          tabsContentObject={tabContentObject}
        />
      </div>

      <div className="color-sidebar-buttons">
        <UniversalButton
          onClick={onClearHandler}
          labelColor="blue"
          leftIcon={<BinIcon />}
          backgroundHoverColor={"blue-light"}
          backgroundColor={"blue"}
          isFullWidth
          label={"Clear"}
        />
        <UniversalButton
          onClick={applyConditions}
          labelColor={"white"}
          backgroundHoverColor={"orange-light"}
          isFullWidth
          backgroundColor={"orange"}
          label={"Apply"}
        />
      </div>
    </div>
  );
};

export default ColorSidebarMainContent;
